function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
var ButtonGroup = require("react-components/button-group.jsx");
var React = require("react");

var _require = require("../../mixins/changeable.jsx"),
    ChangeableProps = _require.ChangeableProps;

var DashPicker = function (_React$Component) {
    _inherits(DashPicker, _React$Component);

    function DashPicker() {
        _classCallCheck(this, DashPicker);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    DashPicker.prototype.render = function render() {
        return React.createElement(ButtonGroup, {
            value: this.props.value,
            allowEmpty: false,
            buttons: [{ value: "", content: React.createElement(
                    "span",
                    null,
                    "\u2014"
                ) }, { value: "-", content: React.createElement(
                    "span",
                    null,
                    "\u2013\u2013\u2013"
                ) }, {
                value: "- ",
                content: React.createElement(
                    "span",
                    null,
                    "\u2013\xA0\xA0\u2013"
                )
            }, {
                value: ".",
                content: React.createElement(
                    "span",
                    null,
                    "\xB7\xB7\xB7\xB7"
                )
            }, {
                value: ". ",
                content: React.createElement(
                    "span",
                    null,
                    "\xB7 \xB7 \xB7"
                )
            }],
            onChange: this.props.onChange
        });
    };

    return DashPicker;
}(React.Component);

DashPicker.defaultProps = {
    value: ""
};


module.exports = DashPicker;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/interaction/dash-picker.jsx
 ** module id = 292
 ** module chunks = 0 1
 **/